import { render, staticRenderFns } from "./CaldatesPopup.vue?vue&type=template&id=25127315&scoped=true&"
import script from "./CaldatesPopup.vue?vue&type=script&lang=ts&"
export * from "./CaldatesPopup.vue?vue&type=script&lang=ts&"
import style0 from "./CaldatesPopup.vue?vue&type=style&index=0&id=25127315&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25127315",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
